(function () {
  'use strict';

  var CLARITY_GRADES = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3', 'I1', 'I2', 'I3'];
  var COLOUR_GRADES = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
  var CUT_GRADES = ['IDL', 'EX', 'VG', 'G', 'F'];

  var DEFAULT_CLARITY_TOOLTIPS = {
    FL: 'Flawless diamonds have no inclusions or blemishes visible under 10x magnification.',
    IF: 'Internally flawless diamonds have no inclusions visible under 10x magnification.',
    VVS: 'This grade range includes diamonds which are very, very slightly included. It is almost impossible to detect inclusions under 10x magnification.',
    VS: 'Very slightly included diamonds contain minor inclusions that are difficult to detect under 10x magnification.',
    SI: 'Slightly included diamonds contain noticeable inclusions under 10x magnification that may be visible to the naked eye.',
    I: 'Included diamonds contain inclusions that are often visible without magnification.',
  };

  var DEFAULT_COLOUR_TOOLTIPS = {
    D: 'D is the highest colour grade and appears completely colourless.',
    E: 'E colour diamonds appear colourless to the naked eye.',
    F: 'F colour diamonds appear colourless when viewed face up.',
    G: 'G colour diamonds are near colourless and offer excellent value.',
    H: 'H coloured diamonds are near colourless and still appear white when not compared side by side with higher grades.',
    I: 'I colour diamonds are near colourless with a slight warmth visible under close inspection.',
    J: 'J colour diamonds show faint warmth that may be noticeable in larger stones.',
    K: 'K colour diamonds show a faint yellow tint.',
    L: 'L colour diamonds show a light yellow tint.',
    M: 'M colour diamonds show a noticeable yellow tint.',
    N: 'N colour diamonds show a visible yellow tint.',
  };

  var DEFAULT_CUT_TOOLTIPS = {
    IDL: 'Ideal cut diamonds are cut to precise proportions for maximum brilliance and fire.',
    EX: 'Excellent cut diamonds reflect nearly all light that enters for exceptional sparkle.',
    VG: 'Very Good cut diamonds reflect most light and offer strong brilliance.',
    G: 'Good cut diamonds reflect a fair amount of light for an attractive appearance.',
    F: 'Fair cut diamonds may appear slightly duller because more light escapes through the sides or bottom.',
  };

  function normalizeKey(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function parseTooltipMap(raw, defaults) {
    var map = Object.assign({}, defaults);
    String(raw || '')
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .forEach(function (line) {
        var parts = line.split('|');
        if (parts.length < 2) return;
        map[normalizeKey(parts[0])] = parts.slice(1).join('|').trim();
      });
    return map;
  }

  function normalizeCut(value) {
    var key = normalizeKey(value);
    var map = {
      EX: 'EX',
      EXCELLENT: 'EX',
      VG: 'VG',
      VERYGOOD: 'VG',
      VERY_GOOD: 'VG',
      G: 'G',
      GOOD: 'G',
      F: 'F',
      FAIR: 'F',
      ID: 'IDL',
      IDEAL: 'IDL',
      IDL: 'IDL',
    };
    return map[key] || key || '';
  }

  function formatCaratDisplay(carats, suffix) {
    var value = Number(carats);
    if (!isFinite(value)) return '—';
    var label = value % 1 === 0 ? value.toFixed(1) : value.toFixed(2).replace(/\.?0+$/, '');
    return label + ' ' + (suffix || 'Ct.');
  }

  function closestCaratStep(carats, steps) {
    var value = Number(carats);
    if (!isFinite(value) || !steps || !steps.length) return null;
    var best = steps[0];
    var bestDiff = Math.abs(Number(steps[0]) - value);
    steps.forEach(function (step) {
      var num = Number(step);
      var diff = Math.abs(num - value);
      if (diff < bestDiff) {
        best = step;
        bestDiff = diff;
      }
    });
    return String(best);
  }

  function getClarityGroup(grade) {
    var key = normalizeKey(grade);
    if (key === 'FL' || key === 'IF') return 'FL';
    if (key.indexOf('VVS') === 0) return 'VVS';
    if (key.indexOf('VS') === 0) return 'VS';
    if (key.indexOf('SI') === 0) return 'SI';
    if (key.indexOf('I') === 0) return 'I';
    return key;
  }

  function getConfig(root) {
    var el = root.querySelector('[data-diamond-information-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function setSelectedText(root, key, value) {
    var el = root.querySelector('[data-diamond-info-selected="' + key + '"]');
    if (el) el.textContent = value || '—';
  }

  function positionElementAtTarget(container, targetEl, floatingEl, offsetTop) {
    if (!container || !targetEl || !floatingEl) return;
    var containerRect = container.getBoundingClientRect();
    var targetRect = targetEl.getBoundingClientRect();
    var left = targetRect.left - containerRect.left + targetRect.width / 2;
    floatingEl.style.left = left + 'px';
    floatingEl.style.top = (offsetTop || 0) + 'px';
    floatingEl.hidden = false;
  }

  function activateGrade(container, selector, grade) {
    var key = normalizeKey(grade);
    container.querySelectorAll(selector).forEach(function (el) {
      el.classList.toggle('is-active', normalizeKey(el.getAttribute('data-grade')) === key);
    });
  }

  function setImageCallout(panel, type, text) {
    var callout = panel.querySelector('[data-diamond-info-callout="' + type + '"]');
    if (!callout) return;
    if (text) {
      callout.textContent = text;
      callout.hidden = false;
    } else {
      callout.textContent = '';
      callout.hidden = true;
    }
  }

  function updateCaratPanel(root, item, config) {
    var panel = root.querySelector('[data-diamond-info-panel="carat"]');
    if (!panel) return;

    var steps = config.caratSteps || [];
    var selectedStep = closestCaratStep(item.carats, steps);
    var display = formatCaratDisplay(item.carats, config.caratSuffix);

    setSelectedText(root, 'carat', display);

    if (config.usesChartImage && config.usesChartImage.carat) {
      return;
    }

    activateGrade(panel, '.diamond-information__carat-item', selectedStep);

    var marker = panel.querySelector('[data-diamond-info-marker]');
    var markerLabel = panel.querySelector('[data-diamond-info-marker-label]');
    var activeItem = panel.querySelector('.diamond-information__carat-item.is-active');
    if (marker && markerLabel && activeItem) {
      markerLabel.textContent = display;
      positionElementAtTarget(panel.querySelector('[data-diamond-info-chart="carat"]'), activeItem, marker, 0);
    } else if (marker) {
      marker.hidden = true;
    }
  }

  function bindTooltipNav(panel, grades, getTooltip, onSelect) {
    var tooltip = panel.querySelector('[data-diamond-info-tooltip]');
    if (!tooltip || tooltip._navBound) return;
    tooltip._navBound = true;

    var currentGrade = '';

    function showGrade(grade) {
      currentGrade = normalizeKey(grade);
      onSelect(currentGrade);
      var textEl = tooltip.querySelector('[data-diamond-info-tooltip-text]');
      if (textEl) textEl.textContent = getTooltip(currentGrade) || '';
    }

    var prevBtn = tooltip.querySelector('[data-diamond-info-prev]');
    var nextBtn = tooltip.querySelector('[data-diamond-info-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var idx = grades.indexOf(currentGrade);
        if (idx > 0) showGrade(grades[idx - 1]);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var idx = grades.indexOf(currentGrade);
        if (idx >= 0 && idx < grades.length - 1) showGrade(grades[idx + 1]);
      });
    }

    panel._showTooltipGrade = showGrade;
  }

  function updateClarityPanel(root, item, config) {
    var panel = root.querySelector('[data-diamond-info-panel="clarity"]');
    if (!panel) return;

    var grade = normalizeKey(item.clarity);
    var tooltips = parseTooltipMap(config.clarityTooltips, DEFAULT_CLARITY_TOOLTIPS);

    setSelectedText(root, 'clarity', grade || '—');

    function getTooltip(key) {
      return tooltips[key] || tooltips[getClarityGroup(key)] || '';
    }

    if (config.usesChartImage && config.usesChartImage.clarity) {
      setImageCallout(panel, 'clarity', getTooltip(grade));
      return;
    }

    activateGrade(panel, '.diamond-information__clarity-cell', grade);

    bindTooltipNav(panel, CLARITY_GRADES, getTooltip, function (selected) {
      activateGrade(panel, '.diamond-information__clarity-cell', selected);
      var active = panel.querySelector('.diamond-information__clarity-cell.is-active');
      var tooltip = panel.querySelector('[data-diamond-info-tooltip]');
      var textEl = panel.querySelector('[data-diamond-info-tooltip-text]');
      if (textEl) textEl.textContent = getTooltip(selected);
      if (tooltip && active) {
        positionElementAtTarget(panel.querySelector('[data-diamond-info-chart="clarity"]'), active, tooltip, 0);
      }
    });

    if (typeof panel._showTooltipGrade === 'function' && grade) {
      panel._showTooltipGrade(grade);
    }
  }

  function updateColourPanel(root, item, config) {
    var panel = root.querySelector('[data-diamond-info-panel="colour"]');
    if (!panel) return;

    var grade = normalizeKey(item.color);
    var tooltips = parseTooltipMap(config.colourTooltips, DEFAULT_COLOUR_TOOLTIPS);

    setSelectedText(root, 'colour', grade || '—');

    if (config.usesChartImage && config.usesChartImage.colour) {
      setImageCallout(panel, 'colour', tooltips[grade] || '');
      return;
    }

    activateGrade(panel, '.diamond-information__colour-gem-btn', grade);

    bindTooltipNav(panel, COLOUR_GRADES, function (key) {
      return tooltips[key] || '';
    }, function (selected) {
      activateGrade(panel, '.diamond-information__colour-gem-btn', selected);
      var active = panel.querySelector('.diamond-information__colour-gem-btn.is-active');
      var tooltip = panel.querySelector('[data-diamond-info-tooltip]');
      var textEl = panel.querySelector('[data-diamond-info-tooltip-text]');
      if (textEl) textEl.textContent = tooltips[selected] || '';
      if (tooltip && active) {
        positionElementAtTarget(panel.querySelector('[data-diamond-info-chart="colour"]'), active, tooltip, 0);
      }
    });

    if (typeof panel._showTooltipGrade === 'function' && grade) {
      panel._showTooltipGrade(grade);
    }
  }

  function updateCutPanel(root, item, config) {
    var panel = root.querySelector('[data-diamond-info-panel="cut"]');
    if (!panel) return;

    var grade = normalizeCut(item.cut);
    var tooltips = parseTooltipMap(config.cutTooltips, DEFAULT_CUT_TOOLTIPS);
    var labels = config.cutLabels || {};

    panel.querySelectorAll('[data-cut-label]').forEach(function (el) {
      var key = normalizeKey(el.getAttribute('data-cut-label'));
      if (labels[key]) el.textContent = labels[key];
    });

    var display = labels[grade] || grade || '—';
    setSelectedText(root, 'cut', display);

    if (config.usesChartImage && config.usesChartImage.cut) {
      setImageCallout(panel, 'cut', tooltips[grade] || '');
      return;
    }

    activateGrade(panel, '.diamond-information__cut-btn', grade);
    panel.querySelectorAll('.diamond-information__cut-item').forEach(function (el) {
      el.classList.toggle('is-active', normalizeKey(el.getAttribute('data-grade')) === grade);
    });

    bindTooltipNav(panel, CUT_GRADES, function (key) {
      return tooltips[key] || '';
    }, function (selected) {
      activateGrade(panel, '.diamond-information__cut-btn', selected);
      panel.querySelectorAll('.diamond-information__cut-item').forEach(function (el) {
        el.classList.toggle('is-active', normalizeKey(el.getAttribute('data-grade')) === selected);
      });
      var active = panel.querySelector('.diamond-information__cut-btn.is-active');
      var tooltip = panel.querySelector('[data-diamond-info-tooltip]');
      var textEl = panel.querySelector('[data-diamond-info-tooltip-text]');
      if (textEl) textEl.textContent = tooltips[selected] || '';
      if (tooltip && active) {
        positionElementAtTarget(panel.querySelector('[data-diamond-info-chart="cut"]'), active, tooltip, 0);
      }
    });

    if (typeof panel._showTooltipGrade === 'function' && grade) {
      panel._showTooltipGrade(grade);
    }
  }

  function populate(item) {
    var root = document.querySelector('[data-diamond-information]');
    if (!root || !item) return;

    var config = getConfig(root);
    updateCaratPanel(root, item, config);
    updateClarityPanel(root, item, config);
    updateColourPanel(root, item, config);
    updateCutPanel(root, item, config);
  }

  window.DiamondInformation = {
    populate: populate,
  };
})();
